import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Seat, SeatsBySection } from '../models';

export type SelectedSeats = { [key: string]: Seat };

@Injectable({
  providedIn: 'root',
})
export class CartService {
  selectedSeats: SelectedSeats = {};
  selectedSeats$: Subject<SelectedSeats> = new Subject<SelectedSeats>();
  selectedSeatsTotalPrice: number = 0;
  selectedSeatsTotalFee: number = 0;
  selectedSeatsTotalPriceWithFees: number = 0;

  selectedSeatsBySection: { [key: string]: SeatsBySection } = {};
  sortedSelectedSeatsBySectionArray: SeatsBySection[] = [];
  sortedSelectedSeatsBySectionArray$: Subject<SeatsBySection[]> = new Subject<
    SeatsBySection[]
  >();

  constructor() {}

  resetCart() {
    this.selectedSeats = {};
    this.selectedSeats$.next({});
    this.sortedSelectedSeatsBySectionArray = [];
    this.sortedSelectedSeatsBySectionArray$.next([]);
    this.selectedSeatsTotalPrice = 0;
    this.selectedSeatsBySection = {};
    this.selectedSeatsTotalFee = 0;
    this.selectedSeatsTotalPriceWithFees = 0;
  }

  getSeatsSections() {
    return Object.keys(this.selectedSeatsBySection) || [];
  }
}
